import { Method } from 'axios';
import { apiCall } from '@/utility/api/apiUtils';
import {
  API_METHOD_POST,
  API_UPDATE_PHASE_SERVICES,
} from '@/constants/apiConstants';
import { generateHash } from '@/utility/auth/generateHashValue';

export interface UpdatePhaseServicesPayload {
  products_services_uuids: string[];
}

export interface UpdatePhaseServicesResponse {
  status: string;
  data?: any;
  message?: string;
}

export const updatePhaseServices = async (
  phaseUuid: string,
  payload: UpdatePhaseServicesPayload,
): Promise<UpdatePhaseServicesResponse> => {
  const method: Method = API_METHOD_POST;
  const url = API_UPDATE_PHASE_SERVICES(phaseUuid);
  const data = payload;

  console.log('API Call Details:', {
    method,
    url,
    data,
    phaseUuid,
  });

  // Convert JSON object to string for hash generation
  const jsonString = JSON.stringify(data);
  const additionalHeaders = {
    hash: generateHash(jsonString),
  };

  try {
    const response = await apiCall({
      method,
      url,
      data,
      headers: additionalHeaders,
    });
    return response; // Return the response data for further use
  } catch (error) {
    console.error('API Call Error:', error);
    throw error; // Re-throw the error to be handled by the caller
  }
};
